import { type QuoteDocumentTemplateSummary } from "@forgepoint/shared";
import type { CreateQuoteDocumentTemplateResult } from "./quoteDocumentTemplatesStore";

/** What the save-as-template sheet should do next with a create response. */
export type SaveAsTemplateOutcome =
  | {
      /** The template was created; close the sheet. */
      kind: "saved";
      template: QuoteDocumentTemplateSummary;
    }
  | {
      /** The name is already used; show a field error on the name input. */
      kind: "name-taken";
      message: string;
    }
  | {
      /** Anything else; show the message as a form-level error. */
      kind: "error";
      message: string;
    };

/** Fallback message when the server refused without one. */
const FALLBACK_MESSAGE = "Failed to save the document as a template";

/**
 * Maps a save-as-template response onto the sheet's next state, keeping the
 * name-collision and generic-failure branches in one testable place.
 * @param result - The create call's result from the templates store
 * @returns The outcome the sheet should render
 */
export function deriveSaveAsTemplateOutcome(
  result: CreateQuoteDocumentTemplateResult,
): SaveAsTemplateOutcome {
  if (result.template) {
    return { kind: "saved", template: result.template };
  }
  if (result.nameTaken) {
    return { kind: "name-taken", message: result.error ?? FALLBACK_MESSAGE };
  }
  return { kind: "error", message: result.error ?? FALLBACK_MESSAGE };
}
